/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import clsx from "clsx";
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";
import Icon from "@mui/material/Icon";

const Root = styled(Box)(({ theme, size = 24, color = 'inherit' }) => ({
  width: size,
  height: size,
  minWidth: size,
  minHeight: size,
  fontSize: size,
  lineHeight: size,
  color: {
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    info: theme.palette.info.main,
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    action: theme.palette.action.active,
    error: theme.palette.error.main,
    disabled: theme.palette.action.disabled,
    inherit: undefined,
  }[color],
}));

const BASESvgIcon = forwardRef((props, ref) => {
  const { children, className = '', size = 24, sx = {}, color = 'inherit' } = props;

  if (!children.includes(":")) {
    return <Icon ref={ref} {...props} />;
  }

  const iconPath = children.replace(":", ".svg#");

  return (
    <Root
      {...props}
      component="svg"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={clsx("shrink-0 fill-current ", className)}
      ref={ref}
      size={size}
      sx={sx}
      color={color}
    >
      <use
        xlinkHref={`${window.location.origin.toString()}/assets/icons/${iconPath}`}
      />
    </Root>
  );
});

BASESvgIcon.propTypes = {
  children: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object,
  color: PropTypes.oneOf([
    "inherit",
    "disabled",
    "primary",
    "secondary",
    "action",
    "error",
    "info",
    "success",
    "warning",
  ]),
};

// BASESvgIcon.defaultProps = {
//   children: "",
//   size: 24,
//   sx: {},
//   color: "inherit",
// };

export default BASESvgIcon;
